<template>
  <section class="locations-page">
    <!-- Locations -->
    <div class="locations">
      <!-- Canada -->
      <article class="location-item">
        <div class="location-content">
          <h2 class="location-title">Canada</h2>
          <div class="location-columns">
            <div class="location-column">
              <strong>Designo Central Office</strong><br>
              3886 Wellington Street<br>
              Toronto, Ontario M9C 3J5
            </div>
            <div class="location-column">
              <strong>Contact</strong><br>
              P : +1 253-863-8967<br>
              M : contact@designo.co
            </div>
          </div>
        </div>
        <div class="location-map canada"></div>
      </article>
      <!-- Australia -->
      <article class="location-item">
        <div class="location-content">
          <h2 class="location-title">Australia</h2>
          <div class="location-columns">
            <div class="location-column">
              <strong>Designo AU Office</strong><br>
              19 Balonne Street <br>
              New South Wales 2443
            </div>
            <div class="location-column">
              <strong>Contact</strong><br>
              P : (02) 6720 9092<br>
              M : contact@designo.au
            </div>
          </div>
        </div>
        <div class="location-map australia"></div>
      </article>
      <!-- United Kingdom -->
      <article class="location-item">
        <div class="location-content">
          <h2 class="location-title">United Kingdom</h2>
          <div class="location-columns">
            <div class="location-column">
              <strong>Designo UK Office</strong><br>
              13 Colorado Way <br>
              Rhyd-y-fro SA8 9GA
            </div>
            <div class="location-column">
              <strong>Contact</strong><br>
              P : 078 3115 1400<br>
              M : contact@designo.uk
            </div>
          </div>
        </div>
        <div class="location-map united-kingdom"></div>
      </article>
    </div>
  </section>
</template>

<script>
export default {

}
</script>
